import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @author Jakub Gereg
 * Based on PromotionStore
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { observable, runInAction } from 'mobx';
import { ReplePromoManagementLayer } from '../../transportLayers/report/ReplePromoManagementLayer';
import { BaseStore } from '../BaseStore';
import { StoreName } from '../StoreName';
import { Map as ImmutableMap } from 'immutable';
/**
 * Persistent store for ReplePromotions
 */

export var ReplePromoStore =
/*#__PURE__*/
function (_BaseStore) {
  _inherits(ReplePromoStore, _BaseStore);

  function ReplePromoStore() {
    var _this;

    _classCallCheck(this, ReplePromoStore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReplePromoStore).apply(this, arguments));
    /** Store name */

    _this.name = StoreName.ReplePromo;
    /** Layer contains methods for fetching data */

    _this.replePromoManagementLayer = new ReplePromoManagementLayer();
    /** List of Promotions */

    _this.list = ImmutableMap();
    /**
     * Fetches filtered Promotions based on the filter.
     * @param filter - filter params
     * @returns a promise with all filtered Promotions=
     */

    _this.filter = function (filter) {
      return _this.replePromoManagementLayer.filterPromotions(filter).then(function (response) {
        runInAction(function () {
          _this.list = _this.list.clear();
          response.forEach(function (promotion) {
            _this.list = _this.list.set(promotion.id, promotion);
          });
        });
      });
    };

    return _this;
  }

  return ReplePromoStore;
}(BaseStore);

__decorate([observable, __metadata("design:type", Object)], ReplePromoStore.prototype, "list", void 0);